export default __webpack_public_path__ + "static/media/baghi.0d636aaf.jpg";